export function buildCreatedStudentEnrollmentPatch(studentId) {
  return { add_student_ids: [studentId] };
}

export function buildAdditiveStudentEnrollmentPatch({ originalStudentIds = [], selectedStudentIds = [] }) {
  const originalIds = new Set(originalStudentIds);
  const addedIds = [...new Set(selectedStudentIds)].filter((id) => !originalIds.has(id));
  return addedIds.length ? { add_student_ids: addedIds } : {};
}

export function reconcileStudentSelectionAfterPersistedAdd({
  refreshedStudents,
  originalStudentIds,
  selectedStudents
}) {
  const originalIds = new Set(originalStudentIds || []);
  const selectedById = new Map((selectedStudents || []).map((student) => [student.id, student]));
  const refreshedById = new Map((refreshedStudents || []).map((student) => [student.id, student]));

  const pendingAddedIds = [...selectedById.keys()].filter((id) => !originalIds.has(id));
  const pendingRemovedIds = new Set(
    [...originalIds].filter((id) => !selectedById.has(id))
  );

  const reconciledIds = [
    ...[...refreshedById.keys()].filter((id) => !pendingRemovedIds.has(id)),
    ...pendingAddedIds.filter((id) => !refreshedById.has(id))
  ];
  const reconciledStudents = reconciledIds
    .map((id) => selectedById.get(id) || refreshedById.get(id))
    .filter(Boolean);
  const refreshedIds = [...refreshedById.keys()];
  const reconciledIdSet = new Set(reconciledIds);

  return {
    selectedStudents: reconciledStudents,
    authoritativeStudentIds: refreshedIds,
    isDirty: reconciledIds.length !== refreshedIds.length
      || refreshedIds.some((id) => !reconciledIdSet.has(id))
  };
}
